import React, { useEffect, useState } from 'react'
import BreadCrames from '../component/BreadCrames'
import { sidebarAction } from '../redux/SidebarSlice'
import ApiConnection, { BaseUrl } from '../utils/ApiConnection'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import Loader from '../utils/Loader'
import { faCamera, faUserLarge } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Profile = () => {

    const [fname, setfname] = useState("")
    const [lname, setlname] = useState("")
    const [email, setemail] = useState("")
    const [phone, setphone] = useState("")
    const [loading, setloading] = useState(false)
    const [pimage, setpimage] = useState('')
    const [pfile, setpfile] = useState('')
    const dispatch = useDispatch()

    const GetProfile = async ()=>{
        setloading(true)
        try {
            const  response = await ApiConnection.get('get-profile')
            if(response?.status == 200){

                setloading(false)
               
                var editData = response.data?.data?.user

                setfname(editData?.first_name)
                setlname(editData?.last_name)
                setemail(editData?.email)
                setphone(editData?.phone)
                setpimage(BaseUrl + editData?.image)
            } else{
              
            }  
        } catch(err){
            setloading(false)
        }
    }

    useEffect(()=>{
        GetProfile()
        dispatch(sidebarAction(false)) 
      },[])

      const UpdateHandler = async () => {

        setloading(true)
        try{
            var FormData = require('form-data');
            var data = new FormData();
            data.append('first_name', fname);
            data.append('last_name', lname);
            data.append('name', fname + ' ' + lname);
            data.append('email', email);
            data.append('phone', phone);
            data.append('image', pfile);
            const response = await ApiConnection.post(`update-profile`, data);
            if(response.status === 200){
                setloading(false)
                toast.success(response?.data?.message);
                GetProfile()
            } else {
                setloading(false)
            }

        } catch(err){
            setloading(false)
            if(err.response.status === 422){
                  toast.error(err.response?.data?.message);   
              
            }
    }
    

}

const HandleImage = async (e) => {
    var file = e.target.files[0];
 
    var reader = new FileReader();
  
    reader.onloadend = async function (e) {
      const fsize = file.size;

      const fileSize = Math.round(fsize / 1024);
      if (fileSize >= 800) {
        toast.error('file size is too large');
      } else {
        setpfile(file)
        setpimage(reader.result)


      }
    };
    reader.readAsDataURL(file);
  };


  return (
    <>
        {loading && <Loader/>}
    <BreadCrames page="Profile" />
    <div className='px-4'>
        <div className='card'>
            <div className='card-header'>
                Profile Information
            </div>
            <div className='card-body'>
            <div className='row'>
            <div className='col-lg-6'>
            <div className='form-group'>
                <label>First Name</label>
                <input type="text" className="form-control" placeholder="First Name"
                value={fname}
                onChange={(e)=>setfname(e.target.value)}
                />
            </div>
            </div>
            <div className='col-lg-6'>
            <div className='form-group'>
                <label>Last Name</label>
                <input type="text" className="form-control" placeholder="Last Name"
                 value={lname}
                 onChange={(e)=>setlname(e.target.value)}
                />
            </div>
            </div>
            <div className='col-lg-6'>
            <div className='form-group'>
                <label>Email</label>
                <input type="email" className="form-control" placeholder="Email"
                value={email}
                onChange={(e)=>setemail(e.target.value)}
                readOnly
                />
            </div>
            </div>
            <div className='col-lg-6'>
            <div className='form-group'>
                <label>Phone Number</label>
                <input type="text" className="form-control" placeholder="Phone Number"
                 value={phone}
                 onChange={(e)=>setphone(e.target.value)}
                 onKeyPress={(event) => {
                     if (!/[0-9]/.test(event.key)) {
                       event.preventDefault();
                     }
                   }}
                   maxLength="10"
                />
            </div>
            </div>
                   <div className='col-lg-12'>
                   <div className='profile-pic mb-3'>
                                {pimage !== null ?
                                      <img src={pimage} alt="profile" width="150"/>
                                      :

                                      <FontAwesomeIcon icon={faUserLarge} />
                                
                                }
                              
                                <div className='file-upload'>
                                    <input type="file" accept="image/*" onChange={HandleImage} className='form-control' />
                                  
                                </div>
                            </div>
                   </div>
            <div className='col-lg-12 mt-2'>
     <div className='form-group text-right'>
                <button type='button' className='btn btn-primary' onClick={UpdateHandler}>Update</button>
            </div>
            </div>
            </div>
            </div>
        </div>
    </div>
</>
  )
}

export default Profile